export enum AbortControllerType {
  CONVERSATION_LIST = "CONVERSATION_LIST",
  CONVERSATION_TOP_LIST = "CONVERSATION_TOP_LIST",
  CONTACT_DETAIL = "CONTACT_DETAIL",
  ROOM_DETAIL = "ROOM_DETAIL",
  MESSAGE_HISTORY = "MESSAGE_HISTORY",
}
export const abortControllers = new Map() as Map<
  AbortControllerType,
  AbortController | null
>;
